import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, Button, TableContainer, TablePagination, TextField, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useSnackbar } from '../context/SnackbarContext';
import api from '../services/api';

const SignatureList: React.FC = () => {
    const [items, setItems] = useState<any[]>([]);
    const [filtered, setFiltered] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate();
    const { exibirMensagem } = useSnackbar();

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await api.get('/api/signatures');
                setItems(res.data || []);
                setFiltered(res.data || []);
            } catch (err: any) {
                console.error(err);
                exibirMensagem && exibirMensagem('Erro ao carregar pedidos de assinatura', 'error');
            } finally {
                setLoading(false);
            }
        })();
    }, [exibirMensagem]);

    useEffect(() => {
        const t = setTimeout(() => {
            const f = items.filter(it => (
                (it._id || '').toString().includes(searchTerm) ||
                (it.tenantId || '').toString().includes(searchTerm) ||
                (it.status || '').toLowerCase().includes(searchTerm.toLowerCase())
            ));
            setFiltered(f);
            setPage(0);
        }, 250);
        return () => clearTimeout(t);
    }, [searchTerm, items]);

    const handleChangePage = (event: unknown, newPage: number) => setPage(newPage);
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => { setRowsPerPage(parseInt(event.target.value, 10)); setPage(0); };

    return (
        <Box sx={{ p: 2 }}>
            <TextField label="Buscar" variant="outlined" fullWidth margin="normal" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
            <Button variant="contained" onClick={() => navigate('/assinaturas')} sx={{ mb: 2 }}>Criar</Button>
            <Paper>
                <TableContainer sx={{ marginTop: '8px' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Tenant</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                const rows = Array.isArray(filtered) ? filtered : [];
                                if (!Array.isArray(filtered)) console.warn('SignatureList: expected filtered to be array, got', filtered);
                                return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((it: any) => (
                                    <TableRow key={it && (it._id || Math.random())}>
                                        <TableCell>{it?._id}</TableCell>
                                        <TableCell>{it?.tenantId}</TableCell>
                                        <TableCell>{it?.status}</TableCell>
                                        <TableCell>{it && it.createdAt ? new Date(it.createdAt).toLocaleString() : ''}</TableCell>
                                        <TableCell>
                                            <IconButton size="small" onClick={() => it && it._id && navigate(`/assinaturas/${it._id}`)}><VisibilityIcon /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ));
                            })()}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination rowsPerPageOptions={[5, 10, 25]} component="div" count={filtered.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
            </Paper>
        </Box>
    );
};

export default SignatureList;
